import React from 'react';

const Minus = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19 12L3 12" stroke="white" strokeWidth="2" />
    <path
      d="M19 12L3 12"
      stroke="url(#paint0_linear_12609_1190)"
      strokeOpacity="0.8"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12609_1190"
        x1="-5"
        y1="11.8151"
        x2="10.6302"
        y2="27.8151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EED7F1" />
        <stop offset="0.084745" stopColor="#FEFCFE" />
        <stop offset="0.191502" stopColor="#DBC1D4" />
        <stop offset="0.285358" stopColor="#6DD2E5" />
        <stop offset="0.400018" stopColor="#7BA0EB" />
        <stop offset="0.509667" stopColor="#BC86F6" />
        <stop offset="0.631842" stopColor="#DCC4F8" />
        <stop offset="0.747457" stopColor="#BFB5C6" />
        <stop offset="0.870443" stopColor="#F5F4F6" />
        <stop offset="1" stopColor="#D7CACE" />
      </linearGradient>
    </defs>
  </svg>
));

Minus.displayName = 'Minus';

export default Minus;
